import React, { Component } from 'react';

export default class About extends Component {
  render() {
    return (
      <div>
        <h1>About This App</h1>
        <p>Just a test...</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/About.js